export default "__VITE_ASSET__D662HZBx__"